import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const ListingViewSignupCta_Box_1 = styled.div`
  text-align: center;
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    text-align: left;
    width: 50%;
  }
`;

export const ListingViewSignupCta_Box_2 = styled.div`
  display: flex;
  justify-content: center;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    width: 50%;
  }
`;

export const ListingViewSignupCta_Hide_1 = styled.div`
  display: none;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    display: block;
  }
`;
